import { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { GameTypeEnumConst } from "../../../constants/GameTypeConst";
import { toAbsoluteUrl } from "../../../utils/CommonHelper";
import * as actions from "../redux/GamePlayAction";
import { GamePlayDialog } from "./gamePlayDialog/GamePlayDialog";

export const GamePlayListing = ({ isDemo = false }) => {
  const {
    gameType,
    companyOffset,
    companyCode,
    scrollPosition,
    gameCode,
    searchName,
  } = useParams();
  const dispatch = useDispatch();

  const gamePlayState = useSelector(({ gamePlay }) => gamePlay, shallowEqual);
  const screenHeight = window.innerHeight;
  const screenWidth = window.innerWidth;
  const [visibleButton, setVisibleButton] = useState("topRight");
  const [dateNow, setDateNow] = useState(Date.now());
  // const isHorizontal = window.orientation === 90 || window.orientation === -90;

  useEffect(() => {
    const queryParams = {
      action: isDemo ? "playdemogame" : "companyplaygameV2",
      companycode: companyCode,
      gamecode: gameCode,
      platform: "mobile",
      gametype: GameTypeEnumConst[parseInt(gameType)],
    };
    dispatch(actions.playGame(queryParams, isDemo));
  }, [companyCode, gameCode]);

  useEffect(() => {
    const myEvent = new CustomEvent("manageNavBar", {
      detail: {
        value: false,
      },
    });

    window.dispatchEvent(myEvent);

    return () => {
      const myEvent = new CustomEvent("manageNavBar", {
        detail: {
          value: true,
        },
      });

      window.dispatchEvent(myEvent);
    };
  }, []);

  const toggleButton = () => {
    switch (visibleButton) {
      case "topRight":
        setVisibleButton("topLeft");
        break;
      case "topLeft":
        setVisibleButton("bottomLeft");
        break;
      case "bottomLeft":
        setVisibleButton("bottomRight");
        break;
      case "bottomRight":
        setVisibleButton("topRight");
        break;
      default:
        setVisibleButton("topRight");
    }
  };

  return (
    <div className="d-flex flex-column">
      <div
        id="gameDepositModalToggleBtn"
        style={{ display: "none" }}
        data-bs-toggle="modal"
        data-bs-target="#gameDepositModal"
      ></div>
      <GamePlayDialog
        toggleButton={toggleButton}
        companyCode={companyCode}
        gameType={GameTypeEnumConst[parseInt(gameType)]}
        companyOffset={companyOffset}
        searchName={searchName}
        scrollPosition={scrollPosition}
        isDemo={isDemo}
      />
      <div style={{ backgroundColor: "black" }}>
        {!gamePlayState.gamePlay || gamePlayState.actionsLoading ? (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ backgroundColor: "black", height: screenHeight }}
          >
            <div
              className="spinner-border"
              role="status"
              style={{ scale: "1.2" }}
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : gamePlayState.gamePlay.code === "1" ? (
          <div
            className="d-flex flex-column align-items-center justify-content-center text-muted"
            style={{ width: "100%", height: screenHeight }}
          >
            <i className="bi bi-search fs-1 mb-3" />
            <div style={{ color: "white" }}>
              {gamePlayState.gamePlay.message}
            </div>
            <div
              style={{
                position: "absolute",
                ...(visibleButton === "bottomLeft"
                  ? { bottom: 5, left: 5 }
                  : visibleButton === "topLeft"
                  ? { top: 5, left: 5 }
                  : visibleButton === "topRight"
                  ? { top: 5, right: 5 }
                  : { bottom: 5, right: 5 }),
              }}
            >
              <div
                style={{ background: "transparent" }}
                data-bs-toggle="modal"
                data-bs-target="#gamePlayModal"
              >
                <img
                  src={toAbsoluteUrl(
                    `/image/${isDemo ? "demo.webp" : "es51.gif"}`
                  )}
                  style={{ width: "40px", height: "40px" }}
                />
              </div>
            </div>
          </div>
        ) : (
          <div>
            <iframe
              key={dateNow}
              title={gameCode}
              style={{
                height: screenHeight,
                width: screenWidth,
              }}
              src={gamePlayState.gamePlay.gameurl}
            />

            <div
              style={{
                position: "absolute",
                ...(visibleButton === "bottomLeft"
                  ? { bottom: 5, left: 5 }
                  : visibleButton === "topLeft"
                  ? { top: 5, left: 5 }
                  : visibleButton === "topRight"
                  ? { top: 5, right: 5 }
                  : { bottom: 5, right: 5 }),
              }}
            >
              <div
                style={{ background: "transparent" }}
                data-bs-toggle="modal"
                data-bs-target="#gamePlayModal"
              >
                <img
                  src={toAbsoluteUrl(
                    `/image/${isDemo ? "demo.webp" : "es51.gif"}`
                  )}
                  style={{ width: "40px", height: "40px" }}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
